<div class="p-7">

  <!-- ── Header ────────────────────────────────────────────────────────── -->
  <div class="flex items-start justify-between mb-6 flex-wrap gap-4">
    <div class="flex items-center gap-3">
      <a [routerLink]="['/marketing-forms']"
        class="flex-shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
      </a>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">{{ form?.name }}</p>
        <h1 class="text-[1.5rem] font-bold text-gray-900 dark:text-white leading-tight">Envíos</h1>
      </div>
    </div>

    <a [routerLink]="['/marketing-forms', formId, 'editor']"
      class="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
      Editar formulario
    </a>
  </div>

  <!-- ── Filtros ───────────────────────────────────────────────────────── -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-5">
    <div class="flex flex-wrap gap-2">
      @for (chip of statusChips; track chip.value) {
        <button (click)="setStatus(chip.value)"
          class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors"
          [class.bg-brand-500]="statusFilter === chip.value"
          [class.text-white]="statusFilter === chip.value"
          [class.dark:bg-white]="statusFilter === chip.value"
          [class.dark:text-gray-900]="statusFilter === chip.value"
          [class.bg-white]="statusFilter !== chip.value"
          [class.text-gray-600]="statusFilter !== chip.value"
          [class.dark:bg-gray-800]="statusFilter !== chip.value"
          [class.dark:text-gray-300]="statusFilter !== chip.value"
          [class.border]="statusFilter !== chip.value"
          [class.border-gray-300]="statusFilter !== chip.value"
          [class.dark:border-gray-600]="statusFilter !== chip.value"
        >{{ chip.label }}</button>
      }
      <button (click)="togglePartial()"
        class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors"
        [class.bg-brand-500]="onlyPartial"
        [class.text-white]="onlyPartial"
        [class.bg-white]="!onlyPartial"
        [class.text-gray-600]="!onlyPartial"
        [class.dark:bg-gray-800]="!onlyPartial"
        [class.dark:text-gray-300]="!onlyPartial"
        [class.border]="!onlyPartial"
        [class.border-gray-300]="!onlyPartial"
        [class.dark:border-gray-600]="!onlyPartial"
      >Solo parciales</button>
    </div>

    <div class="flex items-center gap-2 px-3.5 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg min-w-[280px] max-w-md">
      <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
      <input type="text" placeholder="Buscar por nombre, correo, URL o campaña…"
        [(ngModel)]="searchTerm" (input)="onSearch()"
        class="flex-1 text-sm bg-transparent border-none outline-none text-gray-700 dark:text-white placeholder-gray-400" />
    </div>
  </div>

  <!-- Filtros avanzados: fechas -->
  <div class="flex flex-wrap items-center gap-3 mb-5">
    <div class="flex items-center gap-2 px-2.5 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800">
      <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">Desde</span>
      <input type="date" [(ngModel)]="dateFrom" (ngModelChange)="onDateChange()"
        (click)="$any($event.target).showPicker?.()"
        (focus)="$any($event.target).showPicker?.()"
        class="text-xs bg-transparent border-none outline-none text-gray-700 dark:text-white dark:[color-scheme:dark] cursor-pointer" />
    </div>
    <div class="flex items-center gap-2 px-2.5 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800">
      <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">Hasta</span>
      <input type="date" [(ngModel)]="dateTo" (ngModelChange)="onDateChange()"
        (click)="$any($event.target).showPicker?.()"
        (focus)="$any($event.target).showPicker?.()"
        class="text-xs bg-transparent border-none outline-none text-gray-700 dark:text-white dark:[color-scheme:dark] cursor-pointer" />
    </div>

    @if (hasActiveFilters) {
      <button (click)="resetFilters()"
        class="inline-flex items-center gap-1 px-2.5 py-1.5 text-xs font-medium rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        Limpiar filtros
      </button>
    }
  </div>

  <!-- ── Tabla ─────────────────────────────────────────────────────────── -->
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl overflow-hidden">
    <table class="w-full text-sm">
      <thead>
        <tr class="border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50">
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Fecha</th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Estado</th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Contacto</th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">URL</th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Campaña</th>
          <th class="w-20 px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Parcial</th>
          <th class="w-24 px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Detalle</th>
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          @for (i of [1,2,3,4,5]; track i) {
            <tr class="border-b border-gray-100 dark:border-gray-800">
              <td class="px-4 py-3.5" colspan="7"><div class="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div></td>
            </tr>
          }
        } @else {
          @for (s of submissions; track s.id) {
            <tr (click)="openDetail(s)"
              class="border-b border-gray-100 dark:border-gray-800 cursor-pointer hover:bg-gray-50/50 dark:hover:bg-gray-800/30 transition-colors">
              <td class="px-4 py-3.5 text-gray-700 dark:text-gray-300">{{ s.datetimeSubmitted | date:'d MMM y, HH:mm' }}</td>
              <td class="px-4 py-3.5">
                <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium" [class]="statusColor(s.submissionStatus)">
                  {{ statusLabel(s.submissionStatus) }}
                </span>
              </td>
              <td class="px-4 py-3.5 text-gray-700 dark:text-gray-300">
                @if (s.contactEmail) {
                  {{ s.contactEmail }}
                } @else if (s.contactId) {
                  <span [title]="'Identificador interno: ' + s.contactId">Contacto sin correo registrado</span>
                } @else {
                  <span class="text-gray-400">anónimo</span>
                }
              </td>
              <td class="px-4 py-3.5 text-gray-600 dark:text-gray-300 max-w-xs">
                @if (s.pageUrl) { <span class="font-mono text-xs truncate block">{{ s.pageUrl }}</span> } @else { <span class="text-gray-400">—</span> }
              </td>
              <td class="px-4 py-3.5 text-gray-600 dark:text-gray-300">
                @if (s.utmCampaign) { {{ s.utmCampaign }} } @else { <span class="text-gray-400">—</span> }
              </td>
              <td class="px-4 py-3.5 text-center">
                @if (s.isPartial) {
                  <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-50 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400">Sí</span>
                } @else { <span class="text-gray-400">—</span> }
              </td>
              <td class="px-4 py-3.5 text-center" (click)="$event.stopPropagation()">
                <button (click)="openDetail(s)"
                  class="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                  Detalle
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="px-4 py-16 text-center">
                <div class="flex flex-col items-center gap-2">
                  <svg class="w-10 h-10 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 17v-6m4 6V7m4 10v-2M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"/></svg>
                  <p class="text-sm text-gray-500 dark:text-gray-400">Sin envíos {{ hasActiveFilters ? 'que coincidan con los filtros' : 'todavía' }}</p>
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>

    <!-- Paginación -->
    @if (totalPages > 1 || totalElements > 0) {
      <div class="flex items-center justify-between px-4 py-3 border-t border-gray-200 dark:border-gray-800">
        <p class="text-xs text-gray-500 dark:text-gray-400">
          {{ totalElements }} {{ totalElements === 1 ? 'envío' : 'envíos' }}
        </p>
        <div class="flex items-center gap-1">
          <button (click)="changePage(page - 1)" [disabled]="page === 0"
            class="px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700
                   text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <span class="px-3 py-1.5 text-xs text-gray-700 dark:text-gray-300">
            {{ page + 1 }} / {{ totalPages || 1 }}
          </span>
          <button (click)="changePage(page + 1)" [disabled]="page >= totalPages - 1"
            class="px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700
                   text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    }
  </div>
</div>

<!-- ── Modal detalle del envío (inc30) ───────────────────────────────── -->
<app-modal [isOpen]="!!selected" (close)="closeDetail()" className="max-w-md mx-4">
  @if (selected) {
    <div class="flex flex-col max-h-[80vh]">
      <div class="flex items-start justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-800">
        <div>
          <p class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Envío #{{ selected.id }}</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white mt-1">{{ selected.datetimeSubmitted | date:'d MMM y, HH:mm:ss' }}</p>
        </div>
      </div>

      <div class="flex-1 overflow-y-auto px-5 py-4 space-y-5">

        <!-- Metadatos -->
        <section class="space-y-2">
          <h3 class="text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Metadatos</h3>
          <dl class="grid grid-cols-3 gap-x-3 gap-y-2 text-xs">
            <dt class="col-span-1 text-gray-500 dark:text-gray-400">Estado</dt>
            <dd class="col-span-2">
              <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium" [class]="statusColor(selected.submissionStatus)">
                {{ statusLabel(selected.submissionStatus) }}
              </span>
            </dd>

            <dt class="col-span-1 text-gray-500 dark:text-gray-400">Contacto</dt>
            <dd class="col-span-2 text-gray-800 dark:text-gray-200">
              @if (selected.contactId) {
                <a [routerLink]="['/contactos', selected.contactId]" class="text-brand-600 hover:underline">
                  <span [title]="'Identificador interno: ' + selected.contactId">{{ selected.contactEmail || 'Contacto sin correo registrado' }}</span>
                </a>
              } @else { anónimo }
            </dd>

            <dt class="col-span-1 text-gray-500 dark:text-gray-400">Visitante</dt>
            <dd class="col-span-2 font-mono text-[11px] text-gray-700 dark:text-gray-300 break-all">{{ selected.visitorToken || '—' }}</dd>

            <dt class="col-span-1 text-gray-500 dark:text-gray-400">Página</dt>
            <dd class="col-span-2 font-mono text-[11px] text-gray-700 dark:text-gray-300 break-all">{{ selected.pageUrl || '—' }}</dd>

            @if (selected.isPartial) {
              <dt class="col-span-1 text-gray-500 dark:text-gray-400">Parcial</dt>
              <dd class="col-span-2 text-gray-800 dark:text-gray-200">Sí · llegó al paso {{ selected.stepReached ?? '—' }}</dd>
            }
          </dl>
        </section>

        <!-- UTM -->
        @if (selected.utmSource || selected.utmMedium || selected.utmCampaign) {
          <section class="space-y-2">
            <h3 class="text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">UTM</h3>
            <dl class="grid grid-cols-3 gap-x-3 gap-y-2 text-xs">
              <dt class="col-span-1 text-gray-500 dark:text-gray-400">Source</dt>
              <dd class="col-span-2 text-gray-800 dark:text-gray-200">{{ selected.utmSource || '—' }}</dd>
              <dt class="col-span-1 text-gray-500 dark:text-gray-400">Medium</dt>
              <dd class="col-span-2 text-gray-800 dark:text-gray-200">{{ selected.utmMedium || '—' }}</dd>
              <dt class="col-span-1 text-gray-500 dark:text-gray-400">Campaign</dt>
              <dd class="col-span-2 text-gray-800 dark:text-gray-200">{{ selected.utmCampaign || '—' }}</dd>
            </dl>
          </section>
        }

        <!-- Field values -->
        <section class="space-y-2">
          <h3 class="text-[10px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Valores enviados</h3>
          @if (detailLoading) {
            <p class="text-xs text-gray-500 dark:text-gray-400">Cargando…</p>
          } @else if (!selectedFields.length) {
            <p class="text-xs text-gray-500 dark:text-gray-400">Sin valores registrados.</p>
          } @else {
            <div class="space-y-2">
              @for (fv of selectedFields; track fv.id) {
                <div class="rounded-lg border border-gray-200 dark:border-gray-800 p-3">
                  <p class="text-xs font-medium text-gray-900 dark:text-white">{{ labelForField(fv.formFieldId, fv.fieldKey) }}</p>

                  <p class="text-sm text-gray-700 dark:text-gray-300 mt-2 break-words">{{ displayValue(fv) }}</p>
                  @if (optionLabelFor(fv)) {
                    <p class="text-[10px] text-gray-400 dark:text-gray-500 mt-1"
                       [title]="'Identificador interno de la opción: ' + fv.selectedOptionId">Opción: {{ optionLabelFor(fv) }}</p>
                  }
                </div>
              }
            </div>
          }
        </section>
      </div>
    </div>
  }
</app-modal>

